
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/section/stock",
      function () {
        return require("private-next-pages/section/stock.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/section/stock"])
      });
    }
  